import React, {
  PropsWithChildren,
  ReactNode,
  useEffect,
  useRef,
  useState,
} from "react";
import { useInView } from "react-intersection-observer";

interface FadeInViewProps {
  children: React.ReactNode;
  zIndex?: number; // Add any other props you need
}

export const FadeInView2: React.FC<FadeInViewProps> = ({
  children,
  zIndex,
}) => {
  const [hasScrolled, setHasScrolled] = useState(false);
  const [ref, inView] = useInView({
    threshold: 0.6,
    triggerOnce: true,
  });

  const handleScroll = () => {
    if (window.scrollY > 0 && !hasScrolled) {
      setHasScrolled(true);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [hasScrolled]);

  return hasScrolled ? (
    <div ref={ref} className="fade-in">
      {children}
    </div>
  ) : null;
};
